import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getMetaContent } from 'helpers'

/**
 * Hook untuk mendapatkan logo perusahaan.
 * Prioritas: ownerData.companyLogo (dari API/Redux) → fallback ke og:image meta tag (logo default PasarMikro).
 *
 * @returns {{ logoSrc: string, hasCustomLogo: boolean }}
 */
const useCompanyLogo = () => {
  const { ownerData } = useSelector((s) => s.dashboard)
  const defaultLogo = getMetaContent('og:image')

  const logoSrc = useMemo(() => {
    return ownerData?.logo || ownerData?.companyLogo || defaultLogo
  }, [ownerData?.logo, ownerData?.companyLogo, defaultLogo])

  const hasCustomLogo = useMemo(() => {
    return !!(ownerData?.logo || ownerData?.companyLogo)
  }, [ownerData?.logo, ownerData?.companyLogo])

  return { logoSrc, hasCustomLogo }
}

export default useCompanyLogo
